<template>
  <div v-for="(notifications, date) in formattedNotifications" :key="date">
    <h5 class="text-sm md:text-base px-3 pb-3 pt-2 md:pt-5">
      {{ date }}
    </h5>

    <div
      v-for="notification in notifications"
      :key="notification.id"
      class="bg-white shadow-sm flex flex-row my-0.5"
      :class="[notification.action || notification.unread ? 'cursor-pointer' : '']"
      @click="readAndNavigate(notification)"
    >
      <div
        class="w-2"
        :class="[
          notification.level === 'error'
            ? 'bg-brand-red'
            : notification.level === 'warning'
            ? 'bg-brand-yellow'
            : 'bg-white'
        ]"
      ></div>

      <div
        class="w-5"
        :class="[
          notification.level === 'error'
            ? 'bg-brand-background-light-red'
            : notification.level === 'warning'
            ? 'bg-brand-background-light-yellow'
            : 'bg-white'
        ]"
      ></div>

      <div class="pt-2 pl-1 pr-2" v-if="notification.unread">
        <AlertDot />
      </div>

      <div class="pl-1 pr-2 py-2 flex flex-row w-full">
        <div class="flex flex-col w-4/5">
          <h5>{{ notification.description }}</h5>
          <div class="flex flex-row py-1" v-if="['warning', 'error'].includes(notification.level)">
            <ExclamationIcon
              class="w-5 mr-1"
              :class="[notification.level === 'error' ? 'text-brand-red' : 'text-brand-yellow']"
            />
            <p
              class="italic text-sm"
              :class="[notification.level === 'error' ? 'text-brand-red' : 'text-brand-yellow']"
            >
              <template v-if="notification.level === 'error'">
                <template v-if="notification.action.action_type">
                  Click to resolve action
                </template>
                <template v-else> Error</template>
              </template>
              <template v-else> Attention </template>
            </p>
          </div>

          <p class="text-sm italic text-brand-mid-gray">
            {{ notification.target }}
          </p>
        </div>
        <div class="flex items-start w-1/5">
          <p class="text-sm text-brand-dark-gray">
            {{ formatTime(notification.timestamp) }}
          </p>
          <ChevronRightIcon
            class="w-5 text-brand-green ml-1"
            v-if="notification.action && notification.action.action_type"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ExclamationIcon, ChevronRightIcon } from "@heroicons/vue/outline"
import moment from "moment"

import { mapGetters } from "vuex"
import { NOTIFICATION_GET_LIST, NOTIFICATION_SET_READ } from "@/store/types"

export default {
  components: {
    ExclamationIcon,
    ChevronRightIcon
  },
  computed: {
    ...mapGetters(["getNotifications", "isNotificationLoading"])
  },
  async mounted() {
    if (!this.isNotificationLoading && !this.getNotifications) {
      try {
        await this.$store.dispatch(NOTIFICATION_GET_LIST)
      } catch (err) {
        console.log(err)
      }
    }
  },
  watch: {
    getNotifications: {
      handler(val) {
        // Group bundles by date created
        const formattedNotifications = {}
        if (val && val.length) {
          // Clone the bundle data to format
          const copiedNotifications = JSON.parse(JSON.stringify(val))
          copiedNotifications.map((n) => {
            const created = this.formatDate(n.timestamp)
            if (!formattedNotifications[created]) {
              formattedNotifications[created] = []
            }
            formattedNotifications[created].push(n)
          })
        }
        this.formattedNotifications = formattedNotifications
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      formattedNotifications: null
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format("dddd, M/D")
    },
    formatTime(timestamp) {
      return `${moment(timestamp).format("h:mma")} CST`
    },
    async readAndNavigate(notification) {
      // 1. Set notification item as read
      // 2. if notification.action, navigate to relevant page
      if (notification.unread) {
        await this.$store.dispatch(NOTIFICATION_SET_READ, {
          id: notification.id
        })
      }

      if (notification.action) {
        if (notification.action.action_type === "report") {
          this.$router.push({
            name: "dashboard_view_application_report",
            params: {
              id: notification.action.application_id,
              type: notification.action.report_type
            }
          })
        }

        // if (notification.action.application_id) {
        //   this.$router.push({
        //     name: "dashboard_view_application_summary",
        //     params: {
        //       id: notification.action.application_id
        //     }
        //   })
        // }
      }
    }
  }
}
</script>
